import { ListPageHeaderProps } from '../../../../ui/components/pure/page-headers/list/list-page-header.component';
import { UsersListControlsState } from '../../users.queries';
import { EntityLabel } from '../../../../hooks/use-entity-labels.hook';
import { makeDefineUsersListActions, UserListActions } from '../actions/user-list.actions';

// type UseUserListResult = ReturnType<typeof useUsersList>;

export function makeUsersListPageHeaderProps(
  usersCount: number,
  form: UsersListControlsState,
  userLabel: EntityLabel,
  onFormInput: (update: Partial<UsersListControlsState>) => void,
  setAction: (action: UserListActions) => void,
  projectID: string
): ListPageHeaderProps<UsersListControlsState> {
  return {
    title: userLabel.plural,
    subtitle: `${usersCount} ${usersCount === 1 ? userLabel.singular : userLabel.plural}`,
    controls: {
      form,
      onFormInput,
      inputs: [
        {
          type: 'select',
          label: '',
          field: 'status',
          options: UserStatusOptions,
          isAdvanced: true,
          halfWidthOnMobile: true
        },
        {
          type: 'select',
          label: 'Managed',
          field: 'managed',
          options: UserManagedOptions,
          isAdvanced: true,
          halfWidthOnMobile: true
        },
        {
          type: 'text',
          label: 'Search',
          field: 'searchTerm'
        }
      ],
      singleAction: {
        label: 'Add new',
        onClick: () => setAction(UserListActions.ADD_USER)
      },
      menu: {
        actions: makeDefineUsersListActions(projectID)(setAction)
      }
    }
  };
}

const UserStatusOptions = [
  { label: 'All', value: 'all' },
  { label: 'Active Only', value: 'active' },
  { label: 'Inactive Only', value: 'inactive' }
];

const UserManagedOptions = [
  { label: 'All', value: '' },
  { label: 'Managed', value: 'managed' },
  { label: 'Not Managed', value: 'not-managed' }
];
